import React from "react";
import { connect } from "react-redux";
import { Input } from "reactstrap";
import { gotProperty } from "../../../utils/utility";
import { onUpdateFilters } from "../../../actions/filterActions";
import {
  FEATURE_REQUEST_CATEGORIES,
  FEATURE_REQUEST_PRIORITIES,
} from "../../../constants/featureRequest";

const FeatureRequestFilters = ({ filter, onUpdateFilters }) => {
  const { searchFilters } = filter;

  return (
    <>
      <div className="form-group">
        <label htmlFor="feature-request-search">Search</label>
        <input
          type="text"
          id="feature-request-search"
          placeholder="Title, user, company..."
          className="form-control"
          value={
            gotProperty(searchFilters, "search") ? searchFilters.search : ""
          }
          onChange={(e) => onUpdateFilters("search", e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="feature-request-category">Category</label>
        <Input
          type="select"
          id="feature-request-category"
          value={
            gotProperty(searchFilters, "category")
              ? searchFilters.category
              : ""
          }
          onChange={(e) => onUpdateFilters("category", e.target.value)}
        >
          <option value="">All categories</option>
          {FEATURE_REQUEST_CATEGORIES.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </Input>
      </div>

      <div className="form-group">
        <label htmlFor="feature-request-priority">Priority</label>
        <Input
          type="select"
          id="feature-request-priority"
          value={
            gotProperty(searchFilters, "priority")
              ? searchFilters.priority
              : ""
          }
          onChange={(e) => onUpdateFilters("priority", e.target.value)}
        >
          <option value="">All priorities</option>
          {FEATURE_REQUEST_PRIORITIES.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </Input>
      </div>

      <div className="form-group">
        <label htmlFor="feature-request-paid-status">Paid / Unpaid</label>
        <Input
          type="select"
          id="feature-request-paid-status"
          value={
            gotProperty(searchFilters, "paid_status")
              ? searchFilters.paid_status
              : ""
          }
          onChange={(e) => onUpdateFilters("paid_status", e.target.value)}
        >
          <option value="">All users</option>
          <option value="paid">Paid</option>
          <option value="unpaid">Unpaid</option>
        </Input>
      </div>

      <div className="form-group">
        <label htmlFor="feature-request-is-active">Active on app</label>
        <Input
          type="select"
          id="feature-request-is-active"
          value={
            gotProperty(searchFilters, "is_active")
              ? searchFilters.is_active
              : ""
          }
          onChange={(e) => onUpdateFilters("is_active", e.target.value)}
        >
          <option value="">All</option>
          <option value="yes">Active users</option>
          <option value="no">Inactive users</option>
        </Input>
        <small className="text-muted d-block mt-2">
          Active = logged in within 30 days and has events or bookings in the
          last 90 days.
        </small>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  filter: state.filter,
});

export default connect(mapStateToProps, {
  onUpdateFilters,
})(FeatureRequestFilters);
